import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spinner } from '@components/ui/Spinner';
import apiService from '@services/api';
import { useAuthStore } from '@stores/authStore';

export const QQCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const status = searchParams.get('status');
    const msg = searchParams.get('msg');

    if (status === 'success') {
      // 后端已通过 session 登录，前端获取当前用户信息
      apiService.get<any>('/auth/current-user/')
        .then((res) => {
          const backendUser = res.user as any;
          useAuthStore.setState({
            user: {
              ...res.user,
              level: backendUser.user_level ?? 1,
              level_name: backendUser.level_name ?? '',
              total_xp: backendUser.total_xp ?? 0,
            } as any,
            isAuthenticated: true,
            isLoading: false,
            error: null,
          });
          navigate('/main', { replace: true });
        })
        .catch(() => {
          setErrorMsg('获取用户信息失败，请重新登录');
        });
    } else {
      setErrorMsg(msg || 'QQ 登录失败，请重试');
    }
  }, [searchParams, navigate]);

  if (errorMsg) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <div className="max-w-md w-full text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">QQ 登录失败</h2>
          <p className="text-gray-600 mb-6">{errorMsg}</p>
          <button
            onClick={() => navigate('/login')}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            返回登录
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <Spinner size="lg" />
        <p className="mt-4 text-gray-600">正在完成 QQ 登录...</p>
      </div>
    </div>
  );
};
